@if (isUser$ | async) {
<ul class="breadcrumb">
  @for (route of routes; track $index) {
  <li class="breadcrumb-list">
    @if (!$first) {
    <mat-icon>chevron_right</mat-icon>
    }
    <a mat-button [routerLink]="route.url" [disabled]="$last">
      {{ route.path }}
      @if (route.beta) {
      <span class="beta-badge">beta</span>
      }
    </a>
  </li>
  }
</ul>
}
